/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_st_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The median of that set is 4.5 — the average of the two middle values.`)
};

const es_st_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La mediana de ese conjunto es 4.5 — el promedio de los dos valores centrales.`)
};

const de_st_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Median dieser Menge ist 4,5 — der Durchschnitt der beiden mittleren Werte.`)
};

const nl_st_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De mediaan van die reeks is 4,5 — het gemiddelde van de twee middelste waarden.`)
};

const fr_st_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La médiane de cet ensemble est 4,5 — la moyenne des deux valeurs centrales.`)
};

const it_st_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La mediana di questo insieme è 4,5 — la media dei due valori centrali.`)
};

const pt_br2_st_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A mediana desse conjunto é 4,5 — a média dos dois valores centrais.`)
};

const pt_st_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A mediana desse conjunto é 4,5 — a média dos dois valores centrais.`)
};

const ja_st_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この集合の中央値は4.5 — 中央の2つの値の平均です。`)
};

const zh_st_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`该组数据的中位数为 4.5——中间两个数值的平均值。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const st_ex2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.st_ex2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("st_ex2", locale)
	if (locale === "en") return en_st_ex2(inputs)
	if (locale === "es") return es_st_ex2(inputs)
	if (locale === "de") return de_st_ex2(inputs)
	if (locale === "nl") return nl_st_ex2(inputs)
	if (locale === "fr") return fr_st_ex2(inputs)
	if (locale === "it") return it_st_ex2(inputs)
	if (locale === "pt-BR") return pt_br2_st_ex2(inputs)
	if (locale === "pt") return pt_st_ex2(inputs)
	if (locale === "ja") return ja_st_ex2(inputs)
	return zh_st_ex2(inputs)
};